// Module-level store for the list→week drag payload (readable during dragover, not just drop)
export const listDragState = { current: null };

// Currently highlighted month cell element (direct DOM, no re-render needed)
export const monthDragOverState = { current: null };
